import { DEFAULT_MAX_CHARACTERS } from 'modules/dataDictionary/constants';
import { createRestrictionText } from 'modules/dataDictionary/utils';
import { ReactNode } from 'react';
import { Controller } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';

export const COMPOUND_NAME_INPUT_FIELD_TEXT = {
  inputId: 'compound-name-input-field',
};

export type CompountNameInputFieldProps = {
  labelText: ReactNode;
  maxCharacters?: number;
  name: string;
};

export const CompoundNameInputField = ({
  labelText,
  maxCharacters = DEFAULT_MAX_CHARACTERS,
  name,
}: CompountNameInputFieldProps) => (
  <Controller
    name={name}
    render={({ field: { onChange, value }, fieldState: { error } }) => {
      const restrictionText = createRestrictionText(value.length, maxCharacters);
      return (
        <FormField
          errorText={error?.message}
          hasError={Boolean(error?.message)}
          labelText={labelText}
          restrictionText={restrictionText}
        >
          <InputText
            autoFocus
            data-test={COMPOUND_NAME_INPUT_FIELD_TEXT.inputId}
            onChange={onChange}
            value={value}
          />
        </FormField>
      );
    }}
  />
);
